import { render, staticRenderFns } from "./treeColorful.vue?vue&type=template&id=1d5cffc8"
import script from "./treeColorful.vue?vue&type=script&lang=js"
export * from "./treeColorful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports